const addShopperParams = (
  url,
  searchParams,
  isRaq = false,
  clearCache = false,
  postalCode = null
) => {
  let newUrl = url;

  const postalCodeParam =
    sessionStorage.postalcode ?? searchParams.get('postalcode') ?? postalCode;
  const ezCustomerParam = sessionStorage.ez ?? searchParams.get('ez');
  const bacsParam = sessionStorage.bacs ?? searchParams.get('bacs');

  if (url) {
    if (postalCodeParam && !isRaq) {
      newUrl += '&postalcode=' + postalCodeParam;
    }

    if (ezCustomerParam && !isRaq) {
      newUrl += '&ez=' + ezCustomerParam;
    }

    if (bacsParam) {
      newUrl += `${isRaq ? '&bacId=' : '&bacs='}` + bacsParam;
    }

    if (clearCache) {
      newUrl += `&clearcache=true`;
    }
  }

  return newUrl;
};

export default addShopperParams;
